import type { JSX } from 'react';
import { useNavigate, useRouteError, isRouteErrorResponse } from 'react-router';
import { PATHS } from '@/routes/paths';
import { Button, Card, Notice } from '@/components/primitives';

export function NotFoundPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <Card style={{ maxWidth: 520, margin: '60px auto', textAlign: 'center' }}>
      <h3>Screen not found</h3>
      <p className="muted" style={{ margin: '8px 0 16px' }}>
        That route is not part of this build.
      </p>
      <Button
        variant="primary"
        icon="home"
        onClick={() => {
          void navigate(PATHS.arena);
        }}
      >
        Back to the Arena
      </Button>
    </Card>
  );
}

/**
 * Route error boundary.
 *
 * Shows the actual failure rather than a blank screen. With the HTTP adapter a
 * failed read surfaces here, which is the behaviour the static build is already
 * exercising.
 */
export function RouteError(): JSX.Element {
  const error = useRouteError();
  const navigate = useNavigate();

  const message = isRouteErrorResponse(error)
    ? `${String(error.status)} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unknown error.';

  return (
    <Card style={{ maxWidth: 680, margin: '60px auto' }}>
      <h3>Something went wrong on this screen</h3>
      <Notice tone="bad" className="" style={{ marginTop: 12 }}>
        {message}
      </Notice>
      <div className="row" style={{ marginTop: 16 }}>
        <Button
          variant="primary"
          icon="home"
          onClick={() => {
            void navigate(PATHS.arena);
          }}
        >
          Back to the Arena
        </Button>
        <Button
          variant="secondary"
          icon="refresh"
          onClick={() => {
            window.location.reload();
          }}
        >
          Reload
        </Button>
      </div>
    </Card>
  );
}
